import filterEmptyField from './methods/filterEmptyField';
import logo from '../assets/images/logo.png';

const loadHref = window.location.href;
let vue;

const config = {
  created() {
    if (!vue) {
      // console.warn('[vue-msg] not installed!');
    }
  },
  mounted() {},
  data() {
    return {
      logo: `${logo}`.replace(/^\/\//, `${window.location.protocol}//`),
    };
  },
  methods: {
    /**
     * 添加统计代码
     */
    addCounter() {
      const $counter = document.querySelector('.counter');
      const $cnzz = document.createElement('script');
      $cnzz.src = `//s4.cnzz.com/z_stat.php?id=1273260189&web_id=1273260189&t=${new Date().getTime()}`;
      $counter.innerHTML = '';
      document.querySelector('.counter').appendChild($cnzz);
    },
    // 缩略图
    getImageResize(outSrc, outWidth = 80, outHeight) {
      if (!outSrc) return '';
      const src = typeof outSrc === 'string' ? [outSrc] : outSrc || [];
      const srcs = src.map((itemSrc) => {
        console.log(itemSrc);
        if (!/^http/.test(itemSrc)) return itemSrc;
        const size = outHeight ? `w_${outWidth},h_${outHeight}` : `w_${outWidth}`;
        return `${itemSrc.split('?')[0]}?x-oss-process=image/resize,m_lfit,${size}&t=${new Date().getTime()}`;
      });
      return typeof outSrc === 'string' ? srcs[0] : srcs;
    },
    // 缩略图
    replaceHostCdn(src) {
      if (!src) return '';
      return src.replace('//international.oss-ap-southeast-1.aliyuncs.com', '//oss-int.zeehoev.com');
    },
  },
  computed: {
    isAndroid() {
      return (navigator.userAgent.toLowerCase().match(/android/i) && true) || false;
    },
    isApple() {
      return navigator.userAgent.match(/(iPhone|iPod|iPad);?/i) || false;
    },
    isWechat() {
      return (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) && true) || false;
    },
    isMiniapp() {
      return (navigator.userAgent.toLowerCase().match(/miniProgram/i) && true) || false;
    },
    isQQ() {
      return (navigator.userAgent.toLowerCase().match(/qq/i) && true) || false;
    },
    isWeibo() {
      return (navigator.userAgent.toLowerCase().match(/Weibo/i) && true) || false;
    },
    isApp() {
      return (navigator.userAgent.toLowerCase().match(/cfmoto/i) && true) || false;
    },
    appVersion() {
      if (!this.isApp) return null;
      const userAgent = window.navigator.userAgent;
      return (/(cfmoto|Cfmoto)\/([\d]+\.[\d]+\.[\d]+)/.exec(userAgent) || [])[2];
    },
    isMobile() {
      return (navigator.userAgent.toLowerCase().match(/mobile/i) && true) || false;
    },
    isWeb() {
      return !(this.isWechat || this.isWeibo || this.isApp);
    },
    device() {
      const { width, height } = window.screen;
      const screenAspect = [{ width: 375, height: 812, device: 'iPhoneX' }];
      const isSameScreenAspectRatio = (deviceWidth, deviceHeight, targetWidth, targetHeight) => (deviceHeight / deviceWidth) * targetWidth === targetHeight;
      for (let i = 0; i < screenAspect.length; i++) {
        if (isSameScreenAspectRatio(width, height, screenAspect[i].width, screenAspect[i].height)) {
          return screenAspect[i].device;
        }
      }
      return 'unknown';
    },
    // ios环境微信签名url
    iosHref() {
      return loadHref;
    },
  },
  watch: {},
};
export default {
  mixin: config,
  install(app) {
    app.addCounter = config.methods.addCounter;

    app.isAndroid = config.computed.isAndroid();
    app.isApple = config.computed.isApple();
    app.isWechat = config.computed.isWechat();
    app.isMiniapp = config.computed.isMiniapp();
    app.isQQ = config.computed.isQQ();
    app.isWeibo = config.computed.isWeibo();
    app.isApp = config.computed.isApp();
    app.appVersion = config.computed.appVersion();
    app.isWeb = config.computed.isWeb();
    app.device = config.computed.device();
    app.iosHref = config.computed.iosHref();
    app.mixin(filterEmptyField);
    app.mixin(config);
  },
};
